import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListTags from './list-tags';
import TagDetail from './tag-detail';
import Header from '../common/components/header';
import Sidebar from '../common/components/sidebar';

const TagRoutes = () => (
  <>
    <Header />
    <Sidebar />
    <div className="page-wrapper">
      <div className="content">
        <Routes>
          <Route path="/list-tags" element={<ListTags />} />
          <Route path="/tag-detail/:id" element={<TagDetail />} />
          <Route path="/" element={<ListTags />} />
        </Routes>
      </div>
    </div>
  </>
);

export default TagRoutes; 